import "./FormStyles.css";
import emailjs from "@emailjs/browser";
import React, { useRef } from "react";

const Form = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        // "vxy_mails", outlook service id
        "service_virxee",
        "template_uyfisxa",
        form.current,
        "t2ArpMkhBKk6NoOvF"
      )
      .then(
        (result) => {
          e.target.reset();
          console.log(result.text);
          console.log("Message Sent");
          alert("Message Sent");
        },
        (error) => {
          console.log(error.text);
          alert("Can't send Mails at the moment");
        }
      );
  };

  return (
    <div className="Form">
      <form ref={form} onSubmit={sendEmail} method={postMessage}>
        <label>Your Name</label>
        <input type="text" name="user_name"></input>
        <label>Email</label>
        <input type="email" name="user_email"></input>
        <label>Subject</label>
        <input type="text" name="subject"></input>
        <label>Message</label>
        <textarea
          rows="6"
          placeholder="Enter your Message Here"
          name="message"
        ></textarea>
        <button type="submit" className="btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Form;
